import { IOfferEventType } from 'graphql/types';
import { TOfferEventFormValues } from 'offer/types';

export const INITIAL_VALUES: Pick<
    TOfferEventFormValues,
    | 'trainers'
    | 'trainerApproval'
    | 'minSubscriptions'
    | 'maxSubscriptions'
    | 'descriptionBeforeSubscription'
    | 'descriptionAfterSubscription'
    | 'accessTrainings'
    | 'accessExternalContents'
    | 'accessCourses'
    | 'showParticipantList'
    | 'type'
    | 'waitingList'
    | 'groupManagersCanEnrollParticipants'
> = {
    trainers: [],
    trainerApproval: false,
    minSubscriptions: 0,
    maxSubscriptions: 0,
    descriptionBeforeSubscription: '',
    descriptionAfterSubscription: '',
    accessTrainings: [],
    accessExternalContents: [],
    accessCourses: [],
    showParticipantList: false,
    type: IOfferEventType.Training,
    waitingList: false,
    groupManagersCanEnrollParticipants: false,
};
